import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { showInfoPopup } from '../../../actions/notification-actions';
import { publishScheduledMatches } from '../../../actions/court-scheduler-actions';

export const UNPUBLISHED_WARNING_STORAGE_KEY = 'courtScheduler_doNotShowUnpublishedWarning';

const useCourtSchedularUnpublishedChangesGuard = () => {
    const dispatch = useDispatch();
    const {
        selectedDateCourtConfig,
        selectedFacilityId,
        unPublishedMatchCount = 0,
        publishedDeletedDraftMatchCount = 0,
        matchesSaved = 0,
    } = useSelector(({ courtScheduler }) => courtScheduler);

    const hasUnpublishedMatches = selectedDateCourtConfig && selectedFacilityId && (
        unPublishedMatchCount > 0 ||
        publishedDeletedDraftMatchCount > 0 ||
        matchesSaved?.length > 0
    );

    const guardAction = useCallback((callback) => {
        if (!hasUnpublishedMatches) {
            callback();
            return;
        }

        const doNotShow = localStorage.getItem(UNPUBLISHED_WARNING_STORAGE_KEY) === 'true';
        if (doNotShow) {
            callback();
            return;
        }

        dispatch(showInfoPopup({
            noIcon: true,
            title: null,
            message: 'Your changes have been saved but not yet published live. Are you sure you want to leave this screen without publishing?',
            showCancelButton: true,
            cancelButtonLabel: 'Publish',
            onCancelClick: ({ doNotShowAgain } = {}) => {
                if (doNotShowAgain) {
                    localStorage.setItem(UNPUBLISHED_WARNING_STORAGE_KEY, 'true');
                }
                dispatch(publishScheduledMatches());
            },
            showConfirmButton: true,
            confirmButtonLabel: 'Yes',
            onConfirmClick: ({ doNotShowAgain } = {}) => {
                if (doNotShowAgain) {
                    localStorage.setItem(UNPUBLISHED_WARNING_STORAGE_KEY, 'true');
                }
                callback();
            },
            showCloseButton: true,
            onCloseButtonClick: () => {
                // Do nothing. just the popup should be closed
            },
            enableDoNotShowAgain: true,
        }));
    }, [hasUnpublishedMatches, dispatch]);

    return { guardAction, hasUnpublishedMatches };
};

export default useCourtSchedularUnpublishedChangesGuard;
